const SURVEYS_RESPONSE_CREATE = 'bfb/summary/SURVEYS_RESPONSE_CREATE';
const SURVEYS_RESPONSE_CREATE_SUCCEEDED = 'bfb/summary/SURVEYS_RESPONSE_CREATE_SUCCEEDED';
const SURVEYS_RESPONSE_CREATE_FAILED = 'bfb/summary/SURVEYS_RESPONSE_CREATE_FAILED';

export default {
  SURVEYS_RESPONSE_CREATE,
  SURVEYS_RESPONSE_CREATE_SUCCEEDED,
  SURVEYS_RESPONSE_CREATE_FAILED,
};
